export enum ECookies {
  TOKEN = 'TOKEN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  TOKEN_TYPE = 'TOKEN_TYPE',
  TOKEN_EXPIRES_IN = 'TOKEN_EXPIRES_IN',
}
